exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".progress-bar{border:#000 1px solid;font-size:40px;height:40px}.progress-bar .container{background-color:#41d988;text-align:center;height:100%;align-items:center}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/progressBar.scss"],"names":[],"mappings":"AACA,cACE,sBACA,eACA,WAAA,CACA,yBACE,yBACA,kBACA,YACA,kBAAA,CAAA","file":"progressBar.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n.progress-bar {\n  border: black 1px solid;\n  font-size: 40px;\n  height: 40px;\n  .container {\n    background-color: $green;\n    text-align: center;\n    height: 100%;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./src/components/Shared/progressBar.scss
// module id = 247
// module chunks = 0 1 2 3 5 6